module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2McK2"))).then(() => parcelRequire('1iHdE'));